/**
 * Persist BK design ERP context so /design/* routes still work after refresh
 * (URL no longer has ?sales_order=&customer=).
 */
const STORAGE_KEY = 'bk_design_order_context';

/**
 * @param {string} salesOrder
 * @param {string} customer
 */
export function saveBkDesignOrderContext(salesOrder, customer) {
  if (salesOrder == null || customer == null) return;
  const so = String(salesOrder).trim();
  const cu = String(customer).trim();
  if (!so || !cu) return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ sales_order: so, customer: cu }));
  } catch (e) {
    console.warn('saveBkDesignOrderContext failed', e);
  }
}

/**
 * @returns {{ sales_order: string, customer: string } | null}
 */
export function loadBkDesignOrderContext() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const so = parsed?.sales_order != null ? String(parsed.sales_order).trim() : '';
    const cu = parsed?.customer != null ? String(parsed.customer).trim() : '';
    if (!so || !cu) return null;
    return { sales_order: so, customer: cu };
  } catch {
    return null;
  }
}

export function clearBkDesignOrderContext() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * @param {string | null | undefined} salesOrder
 * @param {string | null | undefined} customer
 * @returns {{ sales_order: string, customer: string } | null}
 */
export function resolveBkDesignOrderContext(salesOrder, customer) {
  const so = salesOrder != null ? String(salesOrder).trim() : '';
  const cu = customer != null ? String(customer).trim() : '';
  if (so && cu) {
    return { sales_order: so, customer: cu };
  }
  const stored = loadBkDesignOrderContext();
  if (stored) return stored;
  return null;
}
